// Writing-group service configs for Post a Project (Atrium Stage 7).
//
// Group-map keyed by the JobPosting boolean column, consumed by services/index.js
// (which spreads WRITING_CONFIGS, DESIGN_MEDIA_CONFIGS, and ENHANCE_TEXT_CONFIGS
// into SERVICE_CONFIGS). See CONFIG-SCHEMA §0.

import { bookWriting } from "./bookWriting"
import { sample } from "./sample"
import { humanizeAi } from "./humanizeAi"
import { outline } from "./outline"

export const WRITING_CONFIGS = {
  book_writing: bookWriting,
  sample,
  humanize_ai: humanizeAi,
  outline,
}
